import PartnerRoutes from './partner';

export default PartnerRoutes;